export default __webpack_public_path__ + "static/media/menuL_icon_05.3fe484b0.png";